/**
 * PageLoader Component
 *
 * Inline loading indicator for page transitions
 * Used as Suspense fallback for lazy-loaded routes
 */

export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="flex flex-col items-center gap-3">
        {/* Spinner */}
        <div
          className="animate-spin rounded-full h-8 w-8 border-b-2"
          style={{ borderColor: 'var(--theme-accent)' }}
        />

        {/* Loading Text */}
        <p
          className="text-xs font-mono"
          style={{ color: 'var(--theme-text-muted)' }}
        >
          Loading page...
        </p>
      </div>
    </div>
  );
}

export default PageLoader;
